<template>
  <div class="user-cta">
    <Icon name="grCameraOff" width="36" class="mb-3"/>
    <div class="mb-5">
      <h4 class="user-cta__title">{{ $t('pages.checkins_detail.no_photos_bought') }}</h4>
    </div>
  </div>
</template>

<script>
export default {
  name: "CtaNoPhotosBought",
  props: {
    eventName: {
      type: String,
      required: true
    },
    picaCode: {
      type: String,
      required: true
    }
  }
}
</script>


<style scoped>

</style>